/**
 * Blog AJAX Pagination - Custom Element
 * Loads blog pagination pages via fetch and updates content without full page reload.
 */
class BlogAjaxPagination extends HTMLElement {
  constructor() {
    super();
    this.boundHandleClick = this.handleClick.bind(this);
    this.boundHandlePopState = this.handlePopState.bind(this);
  }

  connectedCallback() {
    history.replaceState(
      { blogPage: window.location.pathname + window.location.search },
      '',
      window.location.pathname + window.location.search
    );
    this.addEventListener('click', this.boundHandleClick);
    window.addEventListener('popstate', this.boundHandlePopState);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundHandleClick);
    window.removeEventListener('popstate', this.boundHandlePopState);
  }

  async handleClick(e) {
    const link = e.target.closest('.pagination a[href]');
    if (!link || link.hasAttribute('aria-disabled')) return;

    e.preventDefault();
    const url = link.getAttribute('href');
    if (!url) return;

    this.setLoading(true);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to load');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('blog-ajax-pagination');
      if (newContent) {
        this.innerHTML = newContent.innerHTML;
        history.pushState({ blogPage: url }, '', url);
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.location.href = url;
      }
    } catch (err) {
      window.location.href = url;
    } finally {
      this.setLoading(false);
    }
  }

  async handlePopState(e) {
    if (!e.state?.blogPage) return;

    const url = e.state.blogPage;
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('blog-ajax-pagination');
      if (newContent) {
        this.innerHTML = newContent.innerHTML;
      }
    } catch (err) {
      window.location.href = url;
    }
  }

  setLoading(loading) {
    if (loading) {
      this.classList.add('blog-ajax-loading');
      this.style.opacity = '0.6';
      this.style.pointerEvents = 'none';
    } else {
      this.classList.remove('blog-ajax-loading');
      this.style.opacity = '';
      this.style.pointerEvents = '';
    }
  }
}

customElements.define('blog-ajax-pagination', BlogAjaxPagination);
